import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteBlogsApi, deleteCaseStudies, getAllBlogsApi, getCaseStudies, IMG_URL } from "../helper/api_helper";
import { Icon } from "@iconify/react/dist/iconify.js";

const CaseStudyComp = () => {


    const [isPageLoading, setIsPageLoading] = useState(false);

    const [blogData, setBlogData] = useState([]);

    const getAllBlogs = async () => {
        try {
            setIsPageLoading(true);
            const response = await getCaseStudies();

            setBlogData(response.data);

        } catch (error) {

            toast.error("Failed to fetch blogs");
            setBlogData([]);
        } finally {
            setIsPageLoading(false);
        }
    };

    useEffect(() => {
        getAllBlogs();
    }, []);

    const [selectedBlogId, setSelectedBlogId] = useState(null);

    const handleConfirmDelete = async () => {
        if (!selectedBlogId) return;

        // setLoading(true);




        try {
            const data = await deleteCaseStudies({ id: selectedBlogId });
            // getCategoriesData()
            getAllBlogs()

            // toast.success("Delted", { id: toastId });
            const modalEl = document.getElementById('exampleModalEdit');
            const modalBackdrop = document.querySelector('.modal-backdrop');

            modalEl.classList.remove('show');
            modalEl.style.display = 'none';
            modalEl.setAttribute('aria-hidden', 'true');

            if (modalBackdrop) modalBackdrop.remove();
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        } catch (err) {
            console.error("Fetch Error:", err);

            toast.error(
                err || "Something went wrong",
                // { id: toastId }
            );
        } finally {
            // setLoading(false);
            // setSelectedCategoryId(null)
        }

    }


    const getDaysAgo = (dateString) => {
        const blogDate = new Date(dateString);
        const today = new Date();
        const diffTime = Math.abs(today - blogDate);

        const diffMinutes = Math.floor(diffTime / (1000 * 60));
        const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        if (diffMinutes < 1) {
            return 'Just now';
        } else if (diffMinutes < 60) {
            return diffMinutes === 1 ? '1 minute ago' : `${diffMinutes} minutes ago`;
        } else if (diffHours < 24) {
            return diffHours === 1 ? '1 hour ago' : `${diffHours} hours ago`;
        } else {
            return diffDays === 1 ? '1 day ago' : `${diffDays} days ago`;
        }
    };
    return (

        <>
            <div className='row gy-4'>

                {/* Style Two */}


                {blogData.map((item, idx) => (
                    <div className='col-xxl-3 col-lg-4 col-sm-6' key={idx}>
                        <div className='card h-100 p-0 radius-12 overflow-hidden'>
                            <div className='card-body p-0'>
                                <Link
                                    // to='/blog-details'
                                    className='w-100 radius-0 overflow-hidden'

                                    style={{ height: "200px", position: "relative" }}
                                >
                                    <img
                                        src={`${IMG_URL}/${item.image_url}`}
                                        // style={{backgroundO}}

                                        alt=''
                                        className='w-100 h-100 object-fit-cover'
                                    />


                                    <div className="dropdown position-absolute top-0 end-0 me-16 mt-16">
                                        <button
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            className="bg-white-gradient-light text-primary-600 w-32-px h-32-px radius-8 border border-primary-light-white d-flex justify-content-center align-items-center text-white"
                                        >
                                            <Icon
                                                icon="entypo:dots-three-vertical"
                                                className="icon "
                                            />
                                        </button>
                                        <ul className="dropdown-menu p-12 border bg-base shadow">
                                            <li>
                                                <Link
                                                    to={`/edit-case-study?id=${item.id}`}


                                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 d-flex align-items-center gap-10"
                                                >
                                                    Edit
                                                </Link>
                                            </li>
                                            <li>
                                                <button
                                                    onClick={() => setSelectedBlogId(item.id)}
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#exampleModalEdit"
                                                    type="button"
                                                    className="delete-btn dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-danger-100 text-hover-danger-600 d-flex align-items-center gap-10"
                                                >
                                                    Delete
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </Link>
                                <div className='p-20'>
                                    <h6 className='mb-16'>
                                        <Link
                                            // to='/blog-details'
                                            className='text-line-2 text-hover-primary-600 text-xl transition-2'
                                        >
                                            {item.title || " Title"}
                                        </Link>
                                    </h6>
                                    {/* <p className='text-line-3 text-neutral-500 mb-0'>
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis
                                    dolores explicabo corrupti, fuga necessitatibus fugiat adipisci
                                    quidem eveniet enim minus.
                                </p> */}

                                    <div
                                        className='text-line-3 text-neutral-500'
                                        dangerouslySetInnerHTML={{ __html: item.description }}
                                    />
                                    <span className='d-block border-bottom border-neutral-300 border-dashed my-20' />
                                    <div className='d-flex align-items-center justify-content-between flex-wrap gap-6'>
                                        <div className='d-flex align-items-center gap-8'>
                                            {/* <img
                                            src='assets/images/user-list/user-list1.png'
                                            alt=''
                                            className='w-40-px h-40-px rounded-circle object-fit-cover'
                                        /> */}
                                            <div className='d-flex flex-column'>
                                                {/* <h6 className='text-sm mb-0'>John Doe</h6> */}
                                                <span className='text-sm text-neutral-500'>    {getDaysAgo(item.createdAt)}</span>
                                            </div>
                                        </div>
                                        <Link 
                                        target="_blank"
                                            to={`https://shipora.io/case-study/${item?.id}`}
                                            className='btn btn-sm btn-primary-600 d-flex align-items-center gap-1 text-xs px-8 py-6'
                                        >
                                       View In Web
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>))}





            </div>
            <div
                className="modal fade"
                id="exampleModalEdit"
                tabIndex={-1}
                aria-labelledby="exampleModalEditLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                            <h1 className="modal-title fs-5" id="exampleModalEditLabel">
                                Confirm Deletion
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body p-24 text-center">
                            <p className="mb-4 fs-6 text-secondary">
                                Are you sure you want to delete this case study?
                            </p>
                            <div className="d-flex justify-content-center gap-3 mt-3">
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={handleConfirmDelete}
                                >
                                    Confirm
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default CaseStudyComp;
